import Vue from 'vue'
import VueRouter from 'vue-router'
import GetStarted from '../views/getstarted/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'GetStarted',
    component: GetStarted
  }
]

const router = new VueRouter({
  routes
})

export default router
